import { combineReducers } from 'redux';

import MainReducer from './main';
import AuthReducer from './auth';
import ParamsReducer from './params';
import UsersReducer from './users';
import LiveReducer from './live';
import NewsReducer from './news';
import PodcastsReducer from './podcasts';
import PodcastsGroupsReducer from './podcastsGroups';
import PushNotificationsReducer from './pushNotifications';

// Root Reducer
const rootReducer = combineReducers({
    mainReducer: MainReducer,
    authReducer: AuthReducer,
    paramsReducer: ParamsReducer,
    usersReducer: UsersReducer,
    liveReducer: LiveReducer,
    newsReducer: NewsReducer,
    podcastsReducer: PodcastsReducer,
    podcastsGroupsReducer: PodcastsGroupsReducer,
    pushNotificationsReducer: PushNotificationsReducer,
});

export default rootReducer;
